import React, { useState } from 'react';
import axios from 'axios';
import { Error } from '../../../components/dialogs/Error';
import { useAuth } from '../../../context/auth';
import { Status } from '../../../statuses';
import { createDate } from '../../../utilities';
import { 
    InformationDescription, 
    InformationName, 
    StyledInformationWrapper, 
    SuspendedWrapper 
} from '../../CampaignDetails.styles';
import { BannerProps } from './Banner.interface';

export function Banner({ id, status, extraDate, extraDescription, refresh }: BannerProps) {
    const { authToken } = useAuth();
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const bannerType = (status: string) => {
        switch (status) {
            case Status.Suspended:
                return 'suspended';
            case Status.NotApproved:
                return 'not approved'
            default:
                return 'suspended / not approved';
        }
    }
    const reasonType = (status: string) => {
        switch (status) {
            case Status.Suspended:
                return 'suspended';
            case Status.NotApproved:
                return 'not approved'
            default:
                return 'suspended / not approved';
        }
    }
    const startCampaign = () => {
        axios.patch(`${process.env.REACT_APP_BASE_URL}/api/campaign/campaign/${id}/start/`, {}, { headers: { DTOKEN: `${authToken}` } }).then(() => {
            refresh();
        })
        .catch(error => {
            setErrorMessage(error.response.data.message);
            setShowError(true);
        })
    }
    return (
        <>
            {status === Status.Stopped
                ?
                    <StyledInformationWrapper>
                        <InformationDescription>This <b>campaign was stopped</b> on {createDate(extraDate)}</InformationDescription>
                        <button onClick={startCampaign}>start</button>
                    </StyledInformationWrapper>
                :
                    <SuspendedWrapper>
                        <InformationDescription>This <b>campaign was {bannerType(status)}</b> by Admin on {createDate(extraDate)}</InformationDescription>
                        <br />
                        <InformationName>Reason of {reasonType(status)}</InformationName>
                        <InformationDescription>{extraDescription}</InformationDescription>
                    </SuspendedWrapper>
            }
            <Error open={showError} setOpen={setShowError} message={errorMessage} />
        </>
    )
}
